<template>
    <v-card>
        <v-form ref="transferOrderItemForm" @submit.prevent v-model="formValid" :lazy-validation="true">
            <v-card-title>
                {{$props.transferOrderItem.nameText ?  `Edit: ${$props.transferOrderItem.nameText}` : 'Add Item' }}
            </v-card-title>

            <v-divider />

            <v-card-text class="item-card-body">

                <v-row dense >
                    <v-col cols="12" lg="8">
                        <v-autocomplete style="width: calc(100% - 50px); display: inline-block;" label="Item" color="#c42111" v-model="$props.transferOrderItem.item" :items="$props.resources.items" item-text="itemId" item-value="id" :rules="[$store.state.validationFuncs.required($props.transferOrderItem.item, 'Item')]" @change="changedItem">
                            <template v-slot:item="data">
                                <div style="max-width: 800px;">
                                    <v-list-item-content>
                                        <v-list-item-title>{{ data.item.itemId }}</v-list-item-title>
                                        <v-list-item-subtitle>{{ formatItemDescription(data.item.purchaseDescription) }}</v-list-item-subtitle>
                                    </v-list-item-content>
                                </div>
                            </template>
                        </v-autocomplete>

                        <v-menu v-model="itemSearchTableShow" bottom right nudge-bottom="40" nudge-left="380" :close-on-content-click="false" :close-on-click="true">
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn v-on="on" v-bind="attrs" class="ml-2" color="#c42111" width="40" max-width="40" min-width="40"><v-icon>mdi-magnify</v-icon></v-btn>
                            </template>

                            <v-data-table class="elevation-1 ns-item-search-table" height="400" :headers="itemSearchTableHeaders" :items="$props.resources.items" :items-per-page="-1" hide-default-footer fixed-header :search="itemSearchTableSearch" @click:row="itemSearchTableItemClick">
                                <template v-slot:footer>
                                    <v-text-field class="mt-2 ml-2 mr-2" outlined color="#c42111" v-model="itemSearchTableSearch" placeholder="Search" />
                                </template>
                            </v-data-table>
                        </v-menu>
                    </v-col>

                    <!-- <v-col cols="12" lg="3">
                        <v-text-field color="#c42111" type="number" label="Committed" v-model="$props.transferOrderItem.quantityCommitted" disabled />
                    </v-col> -->

                    <!-- <v-col cols="12" lg="3">
                        <v-text-field color="#c42111" type="number" label="Picked" disabled />
                    </v-col>
                    <v-col cols="12" lg="3">
                        <v-text-field color="#c42111" type="number" label="Packed" v-model="$props.transferOrderItem.quantityPacked" />
                    </v-col> -->
                    <!-- <v-col cols="12" lg="3">
                        <v-text-field color="#c42111" type="number" label="Fulfilled" v-model="$props.transferOrderItem.quantityFulfilled" disabled />
                    </v-col>
                    <v-col cols="12" lg="3">
                        <v-text-field color="#c42111" type="number" label="Received" v-model="$props.transferOrderItem.quantityReceived" disabled />
                    </v-col>
                    <v-col cols="12" lg="3">
                        <v-text-field color="#c42111" type="number" label="Back Ordered" v-model="$props.transferOrderItem.quantityBackOrdered" disabled />
                    </v-col> -->

                    
                    <v-col cols="12" lg="2">
                        <!-- <v-text-field color="#c42111" type="number" label="Quantity" v-model="$props.transferOrderItem.quantity" @input="quantityOrTransferPriceChanged" :rules="[$store.state.validationFuncs.positiveFloatRequired($props.transferOrderItem.quantity, 'Quantity')]" /> -->
                        <v-text-field color="#c42111" type="number" label="Quantity" v-model="$props.transferOrderItem.quantity" @input="quantityOrTransferPriceChanged" :rules="[itemQuantityRequired($props.transferOrderItem.useItemSubstitution, $props.transferOrderItem.quantity)]" />
                    </v-col>
                    <v-col cols="12" lg="2">
                        <v-text-field color="#c42111" type="number" label="Available Quantity" v-model="$props.transferOrderItem.availableQuantity" disabled />
                    </v-col>


                    <!-- <v-col cols="12" lg="3">
                        <v-text-field color="#c42111" type="number" label="Transfer Price" v-model="$props.transferOrderItem.transferPrice" @input="quantityOrTransferPriceChanged" />
                    </v-col> -->

                    <!-- <v-col cols="12" lg="3">
                        <v-select color="#c42111" label="Units" v-model="$props.transferOrderItem.units" :items="$props.resources.item_unit_types" />
                    </v-col> -->
                    <!-- <v-col cols="12" lg="3">
                        <v-text-field color="#c42111" type="number" label="Amount" v-model="$props.transferOrderItem.amount" :messages="`${amountCheck ? '' : 'The line total amount is not equal to the item price times the quantity'}`" />
                    </v-col> -->


                    <v-col cols="12" lg="10">
                        <v-text-field color="#c42111" label="Description" v-model="$props.transferOrderItem.description" />
                    </v-col>

                    <v-col cols="12" lg="2">
                        <v-text-field type="number" color="#c42111" label="Order Priority" v-model="$props.transferOrderItem.orderPriority" />
                    </v-col>
                    
                    <!-- <v-col cols="12" lg="6">
                        <v-menu v-model="editExpectedReceiptDate" :close-on-content-click="true" transition="scale-transition" offset-y min-width="290px">
                            <template v-slot:activator="{ on }">
                                <v-text-field color="#c42111" label="Expected Receipt Date" v-model="$props.transferOrderItem.expectedReceiptDate" prepend-inner-icon="event" readonly v-on="on" />
                            </template>
                            <v-date-picker v-model="$props.transferOrderItem.expectedReceiptDate" color="#c42111" scrollable />
                        </v-menu>
                    </v-col> -->

                    <!-- <v-col cols="12" lg="6">
                        <v-select color="#c42111" label="Commit" v-model="$props.transferOrderItem.commitInventory" :items="commitInventoryTypes" item-text="text" item-value="value" />
                    </v-col>
                    <v-col cols="12" lg="6">
                        <v-checkbox color="#c42111" label="Commitment Confirmed" v-model="$props.transferOrderItem.commitmentFirm" />
                    </v-col> -->

                    

                    <!-- <v-col cols="12" lg="12">
                        <v-textarea color="#c42111" label="Options" outlined v-model="$props.transferOrderItem.options" />
                    </v-col> -->

                    <!-- <v-col cols="12" lg="3">
                        <v-checkbox color="#c42111" label="Closed" v-model="$props.transferOrderItem.isClosed" />
                    </v-col>
                    <v-col cols="12" lg="3">
                        <v-text-field color="#c42111" type="number" label="Item FIFO Price" v-model="$props.transferOrderItem.itemFIFOPrice" />
                    </v-col>
                    <v-col cols="12" lg="6">
                        <v-text-field color="#c42111" label="Country of Manufacture" v-model="$props.transferOrderItem.countryOfManufacture" />
                    </v-col>

                    <v-col cols="12" lg="4">
                        <v-text-field color="#c42111" label="Item MPN" v-model="$props.transferOrderItem.itemMPN" />
                    </v-col>
                    <v-col cols="12" lg="4">
                        <v-text-field color="#c42111" label="Manufacture" v-model="$props.transferOrderItem.manufacturer" />
                    </v-col>
                    <v-col cols="12" lg="4">
                        <v-text-field color="#c42111" label="HTS Number" v-model="$props.transferOrderItem.htsNumber" />
                    </v-col> -->

                    <!-- <v-col cols="12" lg="12">
                        <v-text-field color="#c42111" label="Item Display Name" v-model="$props.transferOrderItem.itemDisplayName" />
                    </v-col> -->

                    <!-- <v-col cols="12" lg="4">
                        <v-text-field color="#c42111" label="ECCN Number" v-model="$props.transferOrderItem.eccnNumber" />
                    </v-col>
                    <v-col cols="12" lg="4">
                        <v-select color="#c42111" label="Reason Code (SO)" v-model="$props.transferOrderItem.reasonCode" :items="reasonCodes" item-text="name" item-value="id" />
                    </v-col> -->


                    <v-col cols="12" lg="12">
                        <v-checkbox color="#c42111" label="Use Item Substitution" v-model="$props.transferOrderItem.useItemSubstitution" />
                    </v-col>

                    <v-col cols="12" lg="5">
                        <v-autocomplete label="Original Item" color="#c42111" v-model="$props.transferOrderItem.itemSubstitutionOriginalItem" :items="$props.resources.items" item-text="itemId" item-value="id" :disabled="!$props.transferOrderItem.useItemSubstitution" :rules="[requiredIfItemSub($props.transferOrderItem.useItemSubstitution, $props.transferOrderItem.itemSubstitutionOriginalItem)]"></v-autocomplete>
                    </v-col>

                    <v-col cols="12" lg="5">
                        <v-autocomplete label="To Item Substitution" color="#c42111" v-model="$props.transferOrderItem.itemSubstitutionToItem" :items="$props.resources.items" item-text="itemId" item-value="id" :disabled="!$props.transferOrderItem.useItemSubstitution" :rules="[requiredIfItemSub($props.transferOrderItem.useItemSubstitution, $props.transferOrderItem.itemSubstitutionToItem)]"></v-autocomplete>
                    </v-col>

                    <!-- <v-col cols="12" lg="2">
                        <v-text-field color="#c42111" type="number" label="Item Sub Quantity" v-model="$props.transferOrderItem.itemSubstitutionQuantity" :disabled="!$props.transferOrderItem.useItemSubstitution" :rules="[itemSubQuantityRequired($props.transferOrderItem.useItemSubstitution, $props.transferOrderItem.itemSubstitutionQuantity)]" />
                    </v-col> -->


                    <v-col cols="12" lg="2">
                        <v-text-field color="#c42111" type="number" label="Available Quantity" v-model="$props.transferOrderItem.itemSubstitutionAvailableQuantity" disabled />
                    </v-col>
                    
                </v-row>

            </v-card-text>

            <v-divider />

            <v-card-actions>
                <div class="flex-grow-1"></div>
                <v-btn text class="mr-3" @click="$emit('cancel')">Cancel</v-btn>
                <v-btn text class="mr-0" @click="okClick">Ok</v-btn>
            </v-card-actions>
        </v-form>
    </v-card>
</template>

<script>
export default {
    name: 'TransferOrderItemEdit',
    props: ['transferOrderItem', 'resources'],
    components: {

    },
    data: () => ({
        formValid: true,
        itemSearchTableShow: false,
        itemSearchTableSearch: "",
        itemSearchTableHeaders: [
            { text: 'Item', value: 'itemId', align: 'start', width: '150px', filterable: true },
            { text: 'Description', value: 'purchaseDescription', width: '250px', filterable: true },
            // { text: 'Price', value: 'cost', filterable: false },
            { text: 'Available', value: 'quantityonhand', filterable: false },
        ],
        commitInventoryTypes: [],
        reasonCodes: [],
        editExpectedReceiptDate: false,
        requiredIfItemSub: (useItemSub, value) => (!useItemSub || !!value || 'Required for Item Substitution'),
        itemQuantityRequired: (useItemSub, quantity) => (useItemSub || (!!quantity && Number(quantity) > 0) || 'Quantity must be positive'),
        itemSubQuantityRequired: (useItemSub, quantity) => (!useItemSub || (!!quantity && Number(quantity) > 0) || 'Quantity must be positive')
    }),

    computed: {
        amountCheck() {
            return (this.$props.transferOrderItem.amount == ((this.$props.transferOrderItem.quantity * this.$props.transferOrderItem.transferPrice).toFixed(2)));
        }
    },

    methods: {
        okClick: function() {
            if(this.$refs.transferOrderItemForm.validate()) {
                // check quantities
                if( (!this.$props.transferOrderItem.useItemSubstitution && (Number(this.$props.transferOrderItem.quantity) > Number(this.$props.transferOrderItem.availableQuantity)))
                    || (this.$props.transferOrderItem.useItemSubstitution && (Number(this.$props.transferOrderItem.quantity) > Number(this.$props.transferOrderItem.itemSubstitutionAvailableQuantity))) ) {
                        let availableQuantity = this.$props.transferOrderItem.useItemSubstitution ? this.$props.transferOrderItem.itemSubstitutionAvailableQuantity : this.$props.transferOrderItem.availableQuantity;
                    this.$store.commit('showConfirmModal', {
                        title: 'Warning',
                        message: `You have only ${availableQuantity} available for commitment at this location`,
                        type: 'warning',
                        hideCancel: true,
                        confirmAction: () => { }
                    });
                }
                this.$emit('ok');
            }
        },

        changedItem: function(item) {
            let itemObj = this.$props.resources.items.find(i => i.id == item);
            this.$props.transferOrderItem.description = itemObj.purchaseDescription || "";
            this.$props.transferOrderItem.countryOfManufacture = itemObj.countryOfManufacture ? itemObj.countryOfManufacture.refName : "";
            this.$props.transferOrderItem.itemMPN = itemObj.mpn || "";
            this.$props.transferOrderItem.manufacturer = itemObj.manufacturer || "";
            this.$props.transferOrderItem.htsNumber = itemObj.custitem_aw_hts_export || "";
            this.$props.transferOrderItem.itemDisplayName = itemObj.purchaseDescription || "";
            this.$props.transferOrderItem.eccnNumber = itemObj.custitem_aw_eccn_number || "";
            this.$props.transferOrderItem.binnumber = itemObj.binnumber || "";

            this.$props.transferOrderItem.availableQuantity = itemObj.quantityonhand || "0"; 

            // Item Substitution
            if(itemObj.custitem_aw_item_substitution && itemObj.custitem_aw_item_substitution.id) {
                let itemSubObj = this.$props.resources.items.find(i => i.id == itemObj.custitem_aw_item_substitution.id);
                console.log('ITEM SUB FOUND:  ', itemSubObj);
                this.$props.transferOrderItem.itemSubstitutionOriginalItem = itemObj.id;
                this.$props.transferOrderItem.itemSubstitutionToItem = itemSubObj.id;
                //this.$props.transferOrderItem.itemSubstitutionQuantity = '';
                this.$props.transferOrderItem.itemSubstitutionAvailableQuantity = itemSubObj.quantityonhand || "0";
            }
        },

        quantityOrTransferPriceChanged: function() {
            this.$props.transferOrderItem.amount = (this.$props.transferOrderItem.quantity * this.$props.transferOrderItem.transferPrice).toFixed(2);
        },

        formatItemDescription: function(desc) {
            let maxLength = 80;
            let realMaxLength = maxLength - 3;

            if(desc && desc.length > realMaxLength) {
                return (desc.substring(0, realMaxLength) + "...");
            }
            return desc;
        },

        itemSearchTableItemClick: function(item, itemSlotData, event) {
            this.$props.transferOrderItem.item = item.id;
            this.$nextTick(function() {
                this.changedItem(item.id);
                this.itemSearchTableShow = false;
            });
        }
    },

    created() {
        this.commitInventoryTypes = this.$props.resources.commit_inventory_types || [];
        this.reasonCodes = this.$props.resources.item_reason_codes || [];


        let itemObj = this.$props.resources.items.find(i => i.id == this.$props.transferOrderItem.item);
        if(itemObj) {
            this.$props.transferOrderItem.availableQuantity = itemObj.quantityonhand || "0";
            if(itemObj.custitem_aw_item_substitution && itemObj.custitem_aw_item_substitution.id) {
                let itemSubObj = this.$props.resources.items.find(i => i.id == itemObj.custitem_aw_item_substitution.id);
                this.$props.transferOrderItem.itemSubstitutionAvailableQuantity = itemSubObj.quantityonhand || "0";
            }
        }
    },

    mounted() {
    }
};
</script>

<style scoped>

    .item-card-body {
        max-height: calc(80vh - 40px); 
        height: 400px; 
        overflow: auto;
    }

    .item-price-chip {
        position: absolute;
        right: 10px;
    }

</style>

<style>

    .ns-item-search-table tr {
        cursor: pointer !important;
    }

</style>
